import { render, staticRenderFns } from "./ClawbackModal.vue?vue&type=template&id=2d7fe35a"
import script from "./ClawbackModal.vue?vue&type=script&lang=js"
export * from "./ClawbackModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports